"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedsalonsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedsalonsm` : '') + (description ? ` desc-brandedsalonsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedsalonsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedsalonsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.02 18.32c-.44 0-.8-.6-.8-1.32V8.57c0-.74.36-1.33.8-1.33.44 0 .8.6.8 1.33V17c0 .73-.36 1.32-.8 1.32Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.02 19.76H4.95a.66.66 0 0 1-.65-.5.7.7 0 0 1 .28-.8l3.58-2.4c.1-.07.23-.1.36-.1h2.92c.13 0 .26.03.36.1l3.58 2.4a.7.7 0 0 1 .29.8.67.67 0 0 1-.65.5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.08 12.51h-.5a2.5 2.5 0 0 1-2.51-2.5v-.28h1v.29c0 .83.68 1.5 1.52 1.5h.49v.99Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.74 12.37h-.49v-.99h.5a1.5 1.5 0 0 0 1.5-1.5V9.6h1.01v.3a2.5 2.5 0 0 1-2.52 2.48Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 7.2c0-.82.68-1.49 1.52-1.49.85 0 1.53.67 1.53 1.5v3.08H0V7.2Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.95 7.2c0-.82.68-1.49 1.53-1.49.84 0 1.52.67 1.52 1.5v3.08h-3.05V7.2Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.22 13.33H4.74c-.68 0-1.24-.6-1.24-1.33 0-.74.56-1.33 1.24-1.33h10.48c.69 0 1.24.6 1.24 1.33 0 .74-.56 1.33-1.24 1.33Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.1.61C9.26.65 7.34.35 5.74.05A1.54 1.54 0 0 0 3.9 1.54v6.5c0 .82.68 1.48 1.51 1.48h9.16a1.5 1.5 0 0 0 1.52-1.49V1.51c0-.95-.88-1.65-1.82-1.49-1.53.12-3.3.56-4.15.6V.6Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedsalonsm;